import { render, staticRenderFns } from "./HbSwitch.vue?vue&type=template&id=95063982&scoped=true&"
import script from "./HbSwitch.vue?vue&type=script&lang=js&"
export * from "./HbSwitch.vue?vue&type=script&lang=js&"
import style0 from "./HbSwitch.vue?vue&type=style&index=0&id=95063982&prod&scoped=true&lang=css&"
import style1 from "./HbSwitch.vue?vue&type=style&index=1&id=95063982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95063982",
  null
  
)

export default component.exports